import Admin from "./admin";
import Blog from "./blog";
import Member from "./member";
import BlogCategory from "./blog-category";
import { ContactUs } from "./contact-us";
import Category from "./category";
import Product from "./product";
import Partner from "./partners";
import Sponsor from "./sponsor";
import Gallery from "./gallery";
import Student from "./student";

const api = {
  Admin,
  Blog,
  Member,
  BlogCategory,
  ContactUs,
  Category,
  Product,
  Partner,
  Sponsor,
  Gallery,
  Student,
};

export default api;
